import { backendUrl } from "../../services/api/api";
import { UserRole } from "../../utils/enums/user-role";
import { connect } from "react-redux";

const Swagger = ({ currentUser }) => {
    let groupName = "";

    if (!currentUser) return <div>Chargement...</div>;

    switch (currentUser.role) {
        case UserRole.API_CONSUMER:
            groupName = "ApiLotController";
            break;
        case UserRole.PHYSICAL_LABORATORY:
            groupName = "ApiLotResultController";
            break;
        default:
            return <div>Vous n'avez pas accès à Swagger</div>;
    }

    const swaggerUrl = `${backendUrl}/apidoc/swagger-ui/index.html?urls.primaryName=${groupName}`;

    return (
        <div style={{ height: "100vh" }}>
            <iframe
                src={swaggerUrl}
                title="Swagger Documentation"
                width="100%"
                height="100%"
                style={{ border: "none" }}
            />
        </div>
    );
};

const mapStateToProps = state => ({
    currentUser: state.authReducer.currentUser
});

export default connect(mapStateToProps)(Swagger);
